<template>
    <!-- modify file on single (just name of file) -->
    <v-dialog v-model="dialog" max-width="750px">
        <v-card>
            <v-card-title class="primary">
                <h2>
                    <v-icon dark>file_upload</v-icon>
                    <span class="white--text">Modifier un fichier</span>
                </h2>
                <v-spacer></v-spacer>
                <v-btn small icon @click="onClose">
                    <v-icon dark>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-form ref="form" @submit.prevent=''>
                    <v-container grid-list-xs>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Nom" v-model="model.label" :rules="rules.name" required autofocus></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <!-- actions can, update or delete file -->
                <v-btn round small outline color="primary" @click.native="$eventHub.$emit('open-modal', DeleteFiles,{ entity: entity })"><v-icon>delete</v-icon>Supprimer</v-btn>
                <v-spacer></v-spacer>
                <v-btn round small outline color="primary" @click.native="onClose">Annuler</v-btn>
                <v-btn round depressed small color="primary" @click.native="onValidate">Valider</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import DeleteFiles     from './DeleteFiles.vue'
export default {
    props: {
        entity: {
            required: true
        }
    },
    data() {
        return {
            DeleteFiles,
            dialog: false,
            model: {
                label: '',
            },
            rules: {
                name: [
                    (v) => !!v || 'Nom du fichier obligatoire',
                ],
            },
            tags: [],
            item: ''
        }
    },
    methods: {
        // when modal is open
        open(item) {
            this.dialog = true
            this.model.label = item.label
            this.item = item
            this.$store.dispatch('setSelected', { tableId: 'files', selected: item })
        },
        // when form is validate
        onValidate() {
            this.axios.put(`/api/files/${this.item.id}`, this.model)
            .then(response => {
                this.$eventHub.$emit('reload-list')
                this.onClose()
            })
        },
        // reset the form on close 
        onClose() {
            if(this.$refs.form) {
                this.$refs.form.reset()
            }
            this.dialog = false
            this.$store.dispatch('clearSelected', { tableId: 'files' })
        },
    },
    created(){
        this.$eventHub.$on('close-modal', ()=> {
            this.onClose()
        })
    },
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/files/UpdateFiles.vue